import { Collapse } from 'react-collapse';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import { businessLoanGetURLApi } from '../businessLoanGetURLApi';
import { WEB_URL } from '@/config/endpoints';
import { useRouter } from 'next/router';

export default function AccordionBackLink({ open, backLinks, toggle }) {
  const FINANCING_SECTIONS = [
    'Business Loans',
    'Channel Financing',
    'Export Factoring',
    'Invoice Discounting',
    'Purchase Order Financing',
    'Vendor Financing',
  ];
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const router = useRouter();
  const isPopularShows = router.pathname.startsWith('/finance-glossary');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await businessLoanGetURLApi();
        if (result.success) {
          setData(result.data.data);
        } else {
          setError(result.error);
        }
      } catch (err) {
        setError(err.message || 'An error occurred');
      }
    };
    fetchData();
  }, []);

  const uniqueDataURL = Array.isArray(data)
    ? data.filter((value, index, self) =>
      index === self.findIndex((t) => t.url === value.url)
    ) : [];

  const parsedUniqueData = uniqueDataURL.map((item) => {
    let bannerTitle = null;
    try {
      const parsedData = (typeof item.data === "string" && item.data.includes("bannerData"))
        ? JSON.parse(item.data)
        : item.data;
      bannerTitle = parsedData?.bannerData?.title;
    } catch (e) { }
    return bannerTitle ? { ...item, bannerTitle } : null;
  }).filter(Boolean);
  
  return (
    <>
      {!isPopularShows &&
        <div className='footer-links pt-[45px]'>
          <div className=' border border-bordercolor p-3 rounded-lg cursor-pointer' onClick={toggle}>
            <div className='flex justify-between items-center cursor-pointer'>
              <div>
                <h4 className='text-sm text-secondary font-normal'>Popular searches on Credlix</h4>
              </div>
              <div className=''>
                {open ? <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z" /><path d="M5 11h14v2H5z" /></svg> : <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z" /><path d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z" /></svg>}
              </div>
            </div>
            {parsedUniqueData.length > 0 &&
              <Collapse isOpened={open}>
                <div className='flex flex-wrap'>
                  {FINANCING_SECTIONS.map((label) => {
                    const slug = label.toLowerCase().replace(/ /g, '-');
                    const filteredItems = parsedUniqueData.filter((item) => item.url?.includes(slug));

                    if (filteredItems.length === 0) return null;

                    return (
                      <div key={label} className={`py-2 ${filteredItems.length >= 4 ? 'w-full' : 'w-1/2 sm:w-full'}`}>
                        <div className='mb-1'>
                          <button tabIndex={open ? 0 : -1} className='bg-[#766F6A] text-white text-xs rounded border-none py-xsp px-3 cursor-none'>
                            {label}
                          </button>
                        </div>
                        <div className='flex-wrap flex'>
                          {filteredItems.map((item, index) => (
                            <span key={item._id} className="flex items-center">
                              <Link
                                href={`${WEB_URL}/${item.url}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-xs leading-6 hover:underline text-secondary px-xsp cursor-pointer"
                                tabIndex={open ? 0 : -1}
                              >
                                {item.bannerTitle.replace(",", "")}
                              </Link>
                              {index !== filteredItems.length - 1 && (
                                <span className="px-xsp text-secondary">|</span>
                              )}
                            </span>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </Collapse>}
          </div>
        </div>
      }
    </>
  )
}
